import { LitElement, html, css } from 'lit-element'

import {uploadFile1,uploadImgBase64} from './firebase-uploadfile';
import { generateImg,generateImgReq, img2img } from './js/generate-img-api';
import { ganStyleTypeTo,generateGanStyle } from './js/ganstyle-api';



export default class PixelDrawUiClass extends LitElement {
    constructor () {
      super()
      window.fetch('config.json').then(res => res.json()).then(config => {
        this.defaultIndex = config.defaultIndex
        this.defaultBackend = config.defaultBackend
        this.urlColumn = config.urlColumn || 'url'
        this.init()
      })
    }
  
    init () {
      
        
        
        
    }

    static get properties () {
        return {
          service: { type: Object }
          
        }
    }

    static get styles () {
      return css`
      
      `
    }
    
  render () {
      return html``
  }
  
}

var getCanvas; 

var screenshotBtn=document.getElementById('screenshot')
screenshotBtn.addEventListener('click', async function(){
    //
    var yourLoginStateEle=document.getElementById('yourLoginState');
    if(yourLoginStateEle.value=='0'){
      alert('please log in first');
      return;
    }

    await takeshot();
  });

// Define the function 
// to screenshot the div
async function takeshot() {
  let div = document.getElementById('marker_id');

  // Use the html2canvas
  // function to take a screenshot
  // and append it
  // to the output div
  html2canvas(div).then(
    function (canvas) {
      document
      .getElementById('output').innerHTML='';
      document
      .getElementById('output2').innerHTML='';
      //
  document.getElementById("output3").style.width="0px;"
  document.getElementById("output3").style.height="0px;"
  //
      document
      .getElementById('output2')
      .appendChild(canvas);
      //
      canvas.style.width = "400px";
      canvas.style.height = "300px";
      getCanvas = canvas;
    
    })
document
      .getElementById('output2')
      .a(canvas);
}

async function uploadPixelImg(){
  let div = document.getElementById('marker_id');
  await html2canvas(div).then(
    async function (canvas) {
      // canvas.style.width = "500px";
      // canvas.style.height = "500px";
      getCanvas = canvas;
      //
      const downloadImg = getCanvas.toDataURL("image/png");
      // document.getElementById('screenshot').href = downloadImg;
      // document.getElementById('screenshot').download = "image.png";
      await uploadImgBase64(downloadImg);
    })
  
}

var generateResultBtn=document.getElementById('generateResult')
generateResultBtn.addEventListener('click', async function(){
  var yourLoginStateEle=document.getElementById('yourLoginState');
  var yourSubscribeStateEle=document.getElementById('yourSubscribeState');
  if(yourLoginStateEle.value=='0'){
    alert('please log in first');
    return;
  }
  // if(yourSubscribeStateEle.value=='0'){
  //   alert('please subscribe first');
  //   return;
  // }
  //
  document.getElementById("output3").style.width="0px;"
  document.getElementById("output3").style.height="0px;"
  //
  document.getElementById("search-bar").value='';
  //
  await uploadPixelImg();
  await generateArt('doodle2Pic0');
});

var aiStyleSearchBtn=document.getElementById('aiStyleSearch')
aiStyleSearchBtn.addEventListener('click', async function(){
  var yourLoginStateEle=document.getElementById('yourLoginState');
  var yourSubscribeStateEle=document.getElementById('yourSubscribeState');
  if(yourLoginStateEle.value=='0'){
    alert('please log in first');
    return;
  }
  
  //
  // if(document.getElementById('aiTyleValue').value!='2'){
  //   return;
  // }
  // if(yourSubscribeStateEle.value=='0'){
  //   alert('please subscribe first');
  //   return;
  // }
  var searchInputEle=document.getElementById('search-bar');
  if(searchInputEle.value==''||searchInputEle.value==null||searchInputEle.value==' '){
    alert('please type prompt');
    return;
  }
  //
  document.getElementById('GanStyle_subStyle_id_div').style='display:none;'
  //
  document.getElementById("output3").style.width="0px;"
  document.getElementById("output3").style.height="0px;"
  //
  var aiTyleValue=document.getElementById('aiTyleValue').value;
  //
  await uploadPixelImg();
  await generateArt(aiTyleValue);
});


var settingParams=[0,0,0,'base']
async function generateArt(execAiType){
  //todo 生成藝術
  var aiType=0;
  if(execAiType=='doodle2Pic0'){
    aiType=0;
  }else if(execAiType=='0'){
    aiType=0;
  }else if(execAiType=='1'){
    aiType=1;
  }else if(execAiType=='2'){
    aiType=2;
  }else if(execAiType=='3'){
    aiType=3;
  }else if(execAiType=='4'){
    aiType=4;
  }else if(execAiType=='5'){
    aiType=5;

  }else{

  }
  
  var yourPrompt=document.getElementById('search-bar').value;
  var yourSeedText=Math.floor(Math.random() * (45555 - 1024 + 1)) + 1024;
  var yourNumOutPutText=1;
  // document.getElementById('initFileUrl').value="https://firebasestorage.googleapis.com/v0/b/pixeldraw007.appspot.com/o/okkh4IU63rY5cReBx39dqBomfyB3%2Ftest?alt=media&token=14ffeedd-212b-46df-a49a-66564607ba13"

  var initFileUrl=document.getElementById('initFileUrl').value;
  console.log('initFileUrl:'+initFileUrl)
  var maskFileUrl='';
  var art_width=512;
  var art_height=384;
  console.log('generateImgReq params',aiType,yourPrompt,yourSeedText,yourNumOutPutText,initFileUrl,maskFileUrl,art_width,art_height);
    
   //
   document.getElementById("confirmBtn").style="display:block;"
   document.getElementById("promptDetailDialog").showModal();
   document.getElementById("promptP1").innerHTML = 'in progress,it may take a minute';
   document.getElementById("promptP2").innerHTML = 'if it exceeds one minute, there may be a timeout tip';
   //
  var resultArr=await generateImgReq(aiType,yourPrompt,yourSeedText,yourNumOutPutText,initFileUrl,maskFileUrl,art_width,art_height,settingParams);
  //
  document.getElementById("confirmBtn").style="display:none;"
  document.getElementById("promptDetailDialog").close();
  document.getElementById("promptP1").innerHTML = '';
  //
  if(resultArr=='code:1025,msg:sorry,something wrong'){
    alert('sorry, System response timed out')
    return;
  }
  if(resultArr=='code:1024,msg:sorry,something wrong 1'){
    alert(resultArr)
    return;
  }
  if(resultArr=='code:1024,msg:sorry,something wrong 2'){
    alert(resultArr)
    return;
  }
  if(aiType!=5){
    if (typeof resultData === 'string') {
      console.log('resultData is a string');
      alert(resultData);
      return;
    }
  }
  
  var resultHtml=''
  //
  if(resultArr!=undefined){
    if(aiType==0){
      resultHtml='<br/><img id="resultText" src="'+resultArr[1]+'">';
      document.getElementById('ganStyleInitImgUrlValue').value=resultArr[1];
    }else if(aiType==5){
      resultHtml='<br/><img id="resultText" src="'+resultArr+'">';

    }else{
      for(var i=0;i<resultArr.length;i++){
        resultHtml=resultHtml+'<br/><img id="resultText"'+i+' src="'+resultArr[i]+'">';
      }
      document.getElementById('ganStyleInitImgUrlValue').value=resultArr[0];
    }
    
   
  }
  //
  document.getElementById('output').innerHTML='';
  document.getElementById('output2').innerHTML='';
  document.getElementById('output').innerHTML=resultHtml;
  //
  showGanStyleIcons();
}

// document.getElementById('initFile').addEventListener('click', async function(){
    
//     await uploadFile1(document.getElementById('initFile').files[0]);
//   });


// function showGanStyleIcons(){
//   //
//   var ganStyleTypeHtml='';
//   ganStyleTypeHtml = ganStyleTypeHtml+'<ul class="ganStyleType">'
//   ganStyleTypeHtml = ganStyleTypeHtml+'<li class="icon base"><span class="tooltip">base</span><span class="ganStyle_icon_class"><img id="ganStyle_icon_img_id_1" class="ganStyle_icon_img_class" src="https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f600.png"></img></span></li>'
//   ganStyleTypeHtml = ganStyleTypeHtml+'<li class="icon mona_lisa"><span class="tooltip">mona_lisa</span><span class="ganStyle_icon_class"><img id="ganStyle_icon_img_id_2" class="ganStyle_icon_img_class" src="https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f469-200d-1f9b0.png"></img></span></li>'
//   ganStyleTypeHtml = ganStyleTypeHtml+'<li class="icon modigliani"><span class="tooltip">modigliani</span><span class="ganStyle_icon_class"><img id="ganStyle_icon_img_id_3" class="ganStyle_icon_img_class" src="https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f972.png"></img></span></li>'
//   ganStyleTypeHtml = ganStyleTypeHtml+'<li class="icon cubism"><span class="tooltip">cubism</span><span class="ganStyle_icon_class"><img id="ganStyle_icon_img_id_4" class="ganStyle_icon_img_class" src="https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f602.png"></img></span></li>'
//   ganStyleTypeHtml = ganStyleTypeHtml+'<li class="icon elf"><span class="tooltip">elf</span><span class="ganStyle_icon_class"><img id="ganStyle_icon_img_id_5" class="ganStyle_icon_img_class" src="https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f63b.png"></img></span></li>'
//   ganStyleTypeHtml = ganStyleTypeHtml+'<li class="icon sketch_hq"><span class="tooltip">sketch_hq</span><span class="ganStyle_icon_class"><img id="ganStyle_icon_img_id_6" class="ganStyle_icon_img_class" src="https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f979.png"></img></span></li>'
//   ganStyleTypeHtml = ganStyleTypeHtml+'<li class="icon thomas"><span class="tooltip">thomas</span><span class="ganStyle_icon_class"><img id="ganStyle_icon_img_id_7" class="ganStyle_icon_img_class" src="https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f47a.png"></img></span></li>'
//   ganStyleTypeHtml = ganStyleTypeHtml+'<li class="icon thanos"><span class="tooltip">thanos</span><span class="ganStyle_icon_class"><img id="ganStyle_icon_img_id_8" class="ganStyle_icon_img_class" src="https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f608.png"></img></span></li>'

// ganStyleTypeHtml = ganStyleTypeHtml+'</ul>'
//   ganStyleTypeHtml = ganStyleTypeHtml+'<br/>';
// ganStyleTypeHtml = ganStyleTypeHtml+'<ul class="ganStyleType">'
//   ganStyleTypeHtml = ganStyleTypeHtml+'<li class="icon simpson"><span class="tooltip">simpson</span><span class="ganStyle_icon_class"><img id="ganStyle_icon_img_id_9" class="ganStyle_icon_img_class" src="https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f633.png"></img></span></li>'
//   ganStyleTypeHtml = ganStyleTypeHtml+'<li class="icon witcher"><span class="tooltip">witcher</span><span class="ganStyle_icon_class"><img id="ganStyle_icon_img_id_10" class="ganStyle_icon_img_class" src="https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9b9.png"></img></span></li>'
//   ganStyleTypeHtml = ganStyleTypeHtml+'<li class="icon edvard_munch"><span class="tooltip">edvard_munch</span><span class="ganStyle_icon_class"><img id="ganStyle_icon_img_id_11" class="ganStyle_icon_img_class" src="https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f631.png"></img></span></li>'
//   ganStyleTypeHtml = ganStyleTypeHtml+'<li class="icon ukiyoe"><span class="tooltip">ukiyoe</span><span class="ganStyle_icon_class"><img id="ganStyle_icon_img_id_12" class="ganStyle_icon_img_class" src="https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f977.png"></img></span></li>'
//   ganStyleTypeHtml = ganStyleTypeHtml+'<li class="icon botero"><span class="tooltip">botero</span><span class="ganStyle_icon_class"><img id="ganStyle_icon_img_id_13" class="ganStyle_icon_img_class" src="https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f47c.png"></img></span></li>'
//   ganStyleTypeHtml = ganStyleTypeHtml+'<li class="icon shrek"><span class="tooltip">shrek</span><span class="ganStyle_icon_class"><img id="ganStyle_icon_img_id_14" class="ganStyle_icon_img_class" src="https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9df.png"></img></span></li>'
//   ganStyleTypeHtml = ganStyleTypeHtml+'<li class="icon joker"><span class="tooltip">joker</span><span class="ganStyle_icon_class"><img id="ganStyle_icon_img_id_15" class="ganStyle_icon_img_class" src="https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f921.png"></img></span></li>'
//   ganStyleTypeHtml = ganStyleTypeHtml+'<li class="icon pixar"><span class="tooltip">pixar</span><span class="ganStyle_icon_class"><img id="ganStyle_icon_img_id_16" class="ganStyle_icon_img_class" src="https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f9dc-200d-2640-fe0f.png"></img></span></li>'

// ganStyleTypeHtml = ganStyleTypeHtml+'</ul>'
//   ganStyleTypeHtml = ganStyleTypeHtml+'<br/>';
// ganStyleTypeHtml = ganStyleTypeHtml+'<ul class="ganStyleType">'
//   ganStyleTypeHtml = ganStyleTypeHtml+'<li class="icon zombie"><span class="tooltip">zombie</span><span class="ganStyle_icon_class"><img id="ganStyle_icon_img_id_17" class="ganStyle_icon_img_class" src="https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f648.png"></img></span></li>'
//   ganStyleTypeHtml = ganStyleTypeHtml+'<li class="icon werewolf"><span class="tooltip">werewolf</span><span class="ganStyle_icon_class"><img id="ganStyle_icon_img_id_18" class="ganStyle_icon_img_class" src="https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1fae3.png"></img></span></li>'
//   ganStyleTypeHtml = ganStyleTypeHtml+'<li class="icon groot"><span class="tooltip">groot</span><span class="ganStyle_icon_class"><img id="ganStyle_icon_img_id_19" class="ganStyle_icon_img_class" src="https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f4a9.png"></img></span></li>'
//   ganStyleTypeHtml = ganStyleTypeHtml+'<li class="icon ssj"><span class="tooltip">ssj</span><span class="ganStyle_icon_class"><img id="ganStyle_icon_img_id_20" class="ganStyle_icon_img_class" src="https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f478.png"></img></span></li>'
//   ganStyleTypeHtml = ganStyleTypeHtml+'<li class="icon rick_morty_cartoon"><span class="tooltip">rick_morty_cartoon</span><span class="ganStyle_icon_class"><img id="ganStyle_icon_img_id_21" class="ganStyle_icon_img_class" src="https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f644.png"></img></span></li>'
//   ganStyleTypeHtml = ganStyleTypeHtml+'<li class="icon anime"><span class="tooltip">anime</span><span class="ganStyle_icon_class"><img id="ganStyle_icon_img_id_22" class="ganStyle_icon_img_class" src="https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f440.png"></img></span></li>'
//   ganStyleTypeHtml = ganStyleTypeHtml+'<li class="icon white_walker"><span class="tooltip">white_walker</span><span class="ganStyle_icon_class"><img id="ganStyle_icon_img_id_23" class="ganStyle_icon_img_class" src="https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f976.png"></img></span></li>'
//   ganStyleTypeHtml = ganStyleTypeHtml+'<li class="icon zuckerberg"><span class="tooltip">zuckerberg</span><span class="ganStyle_icon_class"><img id="ganStyle_icon_img_id_24" class="ganStyle_icon_img_class" src="https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f617.png"></img></span></li>'

// ganStyleTypeHtml = ganStyleTypeHtml+'</ul>'
//   ganStyleTypeHtml = ganStyleTypeHtml+'<br/>';
// ganStyleTypeHtml = ganStyleTypeHtml+'<ul class="ganStyleType">'
//   ganStyleTypeHtml = ganStyleTypeHtml+'<li class="icon disney_princess"><span class="tooltip">disney_princess</span><span class="ganStyle_icon_class"><img id="ganStyle_icon_img_id_25"  class="ganStyle_icon_img_class" src="https://cdn.jsdelivr.net/npm/emoji-datasource-apple/img/apple/64/1f439.png"></img></span></li>'
  
//   ganStyleTypeHtml = ganStyleTypeHtml+'</ul>'

//   var resultHtml='<div id="GanStyle_subStyle_id" class="message ganStyleType_icon">'
//   resultHtml=resultHtml+ganStyleTypeHtml
//   resultHtml=resultHtml+'</div>'
//   document.getElementById('output').innerHTML = document.getElementById('output').innerHTML + resultHtml;
// }

function showGanStyleIcons(){
  document.getElementById('GanStyle_subStyle_id_div').style='display:block;'
 
}

$(".ganStyle_icon_img_class").each(function(){
  //
  $(this)[0].addEventListener("click", async () => {
    console.log($(this)[0].id);
    // document.getElementById('ganStyleInitImgUrlValue').value='https://replicate.delivery/pbxt/naqJVfD5x7UlO6hi38gSSNPOAKLoqae6fY1RLy2tny0xD9dhA/out-0.png'
    // document.getElementById('ganStyleInitImgUrlValue').value='https://dalle-photo.web.app/assets/ganstyle-demo/out1.jpg'
    var ii=$(this)[0].id.split('_')[4];
    var selectedGanStyleType=await ganStyleTypeTo(parseInt(ii))
    await generateGanStyle('5',selectedGanStyleType);
    
    showGanStyleIcons();
  })
  
});

function test(){
  alert('1')
}